var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.item.info != null &&
      typeof _vm.item.info != 'undefined' &&
      !['width', 'length', 'height', 'weight'].includes(_vm.item.attribute.name) &&
      _vm.item.attribute.calculationrule_id &&
      _vm.item.attribute.calculationrule_id > 0
  )?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
  var on = ref.on;
  var attrs = ref.attrs;
return [_c('v-icon',_vm._g({attrs:{"bind":"attrs","small":""},on:{"click":function($event){return _vm.showTestResult(_vm.item.attribute.calculationrule_id)}}},on),[_vm._v("mdi-information-outline")])]}}],null,false,4209347299)},[_c('span',{staticClass:"infoContainer",domProps:{"innerHTML":_vm._s(_vm.item.info)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }